import React from 'react';
import { useTranslation } from 'react-i18next';
import { IMAGES } from '../layout/theme';

const WithUs = () => {
    const { t } = useTranslation();

    const scrollToContact = () => {
        const contactSection = document.querySelector('.main-contact');
        if (contactSection) {
            contactSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <>
            <div className="banner-animate">
                <span className="stars">
                    <img src={IMAGES.Star1} alt="Stars"/>
                </span>
                <span className="shooting-star shooting-star1">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star"/>
                </span>
                <span className="shooting-star shooting-star2">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star"/>
                </span>
                <span className="shooting-star shooting-star3">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star"/>
                </span>
                <span className="shooting-star shooting-star4">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star"/>
                </span>
                <span className="shooting-star shooting-star5">
                    <img src={IMAGES.ShootingStar} alt="Shooting Star"/>
                </span>
            </div>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="with-us-content">
                            <span className="sub-title">{t('withUs.subtitle')}</span>
                            <h6 className="h4-title">{t('withUs.title')}</h6>
                            <button
                                onClick={scrollToContact}
                                className="sec-btn lg"
                                style={{
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                <span>{t('withUs.contactUsNow')}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WithUs;